import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { SITE_URL } from '../../config/env';

// canonicalPath: sorgu parametresi anlam taşıyan sayfalarda (ör. /ilanlar?tab=roommates) kanonik adres
const SEO = ({ title, description, image, type = 'website', canonicalPath }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const currentUrl = `${SITE_URL}${canonicalPath || location.pathname}`;

  const defaultTitle = t('seo.defaultTitle');
  const defaultDescription = t('seo.defaultDescription');
  const defaultImage = `${SITE_URL}/og-image.jpg`;

  const seoTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoImage = image || defaultImage;

  return (
    <Helmet>
      {/* Temel Meta Etiketleri */}
      <html lang={i18n.language} />
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph Meta Etiketleri */}
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={i18n.language} />

      {/* Twitter Meta Etiketleri */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
    </Helmet>
  );
};

export default SEO; 